import React, { useState } from "react";
import {
  Modal,
  Typography,
  Space,
  Button,
  Tag,
  Divider,
  Alert,
  Tooltip,
  Flex,
  Row,
  Col,
} from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { CampaignRegisteredChannel } from "../../models/campaign";
import Scan from "./Scan";

const { Title, Text } = Typography;

interface ManageConfigurationModalProps {
  open: boolean;
  onClose: () => void;
  accountEmail: string;
  phones: CampaignRegisteredChannel[] | [];
  onAddNew: () => void;
  onReactivate: (id: number | undefined) => void;
}

const SectionHeader: React.FC<{ title: string; extra?: React.ReactNode }> = ({
  title,
  extra,
}) => (
  <Flex
    align="center"
    justify="space-between"
    style={{ backgroundColor: "#CBD5E1", padding: 12 }}
  >
    <Title level={5} style={{ margin: 0 }}>
      {title}
    </Title>
    {extra}
  </Flex>
);

const statusTag = (status: boolean) =>
  status ? (
    <Button
      style={{
        backgroundColor: "#D1FADF",
        borderColor: "#D1FADF",
        color: "#027A48",
      }}
    >
      Active
    </Button>
  ) : (
    <Button
      style={{
        backgroundColor: "#FEE2E2",
        borderColor: "#FEE2E2",
        color: "#B91C1C",
        marginRight: 5,
      }}
    >
      Expired
    </Button>
  );

const ManageConfigurationModal: React.FC<ManageConfigurationModalProps> = ({
  open,
  onClose,
  accountEmail,
  phones,
  onAddNew,
  onReactivate,
}) => {
  return (
    <>
      <Modal
        className="manage-configuration-modal"
        open={open}
        onCancel={onClose}
        footer={null}
        width={550}
        title={
          <Title level={4} style={{ margin: 0 }}>
            Manage Configuration
          </Title>
        }
      >
        <div
          style={{
            border: "1px solid #F1F5F9",
            borderRadius: 2,
          }}
        >
          <SectionHeader title="Account Information" />
          <Space style={{ padding: 12 }}>
            <MailOutlined />
            <Text>{accountEmail}</Text>
          </Space>
        </div>

        <div
          style={{
            border: "1px solid #F1F5F9",
            borderRadius: 2,
            margin: "15px 0px",
          }}
        >
          <SectionHeader
            title="Connected Mobile Number"
            extra={
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onAddNew}
                disabled={phones.length > 1}
              >
                Add New
              </Button>
            }
          />

          {phones.map((p) => (
            <Row
              gutter={[12, 12]}
              justify={"space-around"}
              style={{ padding: 12, borderBottom: "1px solid #F1F5F9" }}
            >
              <Col span={12}>
                <PhoneOutlined style={{ marginRight: 5 }} />
                <Text strong>
                  +{p.ContactIdd} {p.ContactNumber}
                </Text>
              </Col>
              <Col span={12} style={{ justifyContent: "end", display: "flex" }}>
                {statusTag(p.Status)}
                {!p.Status && (
                  <Button type="primary" onClick={() => onReactivate(p.Id)}>
                    Reactivate
                  </Button>
                )}
              </Col>
            </Row>
          ))}
        </div>

        <Alert
          type="info"
          showIcon
          message="WhatsApp sessions are time-limited. Once a session expires, you will receive an SMS and email notification prompting you to reactivate the connection by scanning a new QR code."
        />
      </Modal>
    </>
  );
};

export default ManageConfigurationModal;
